import { useState, useEffect } from "react";
import { InputBox, SubmitButton, TextAreaBox } from "../../components/Input";
import { Link } from "react-router-dom";
import { API_URL } from "../../config";
import axios from "axios";
import { showToast } from "../../components/toast";
import CompanyHeader from "./CompanyHeader";

const ConfigForm = () => {
  const [formData, setFormData] = useState({
    firebase_key: "",
    sms_sender: "",
    sms_apikey: "",
    smtp_host: "",
    smtp_username: "",
    smtp_password: "",
    smtp_print_username: "",
    smtp_print_password: "",
    smtp_secure: "",
    smtp_port: "",
    emailfrom: "",
    mailer_name: "",
    p_company: "",
    p_address: "",
    p_email: "",
    p_phone: "",
    p_gstin: "",
    p_subject: "",
    p_message: "",
    p_notes: "",
    p_tnc: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");

  // Fetch data from an API or load it dynamically here
  const fetchCompany = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}settings/company/Configurations`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      setFormData(response.data.data || {});
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompany();
  }, []);

  // Handle changes in input fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.smtp_print_username)) {
      showToast.error("Please enter a valid email address.");
      setLoading(false);
      return;
    }


    try {
      const response = await axios.post(
        `${API_URL}settings/company/configuration/save?id=${formData.id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success === true) {
        showToast.success(response.data.message);
        fetchCompany();
      } else {
        showToast.error(response.data.message);
      }
    } catch (error) {
      showToast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <header>{/* You can include your header component here */}</header>

      <div id="content" className="">
        <CompanyHeader />
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <form
            onSubmit={handleSubmit}
            className="stdform"
            encType="multipart/form-data"
          >
            <div className="panel-heading border-0">
              <span className="panel-title">Edit Configurations Details</span>
            </div>
            <div className="panel-body">
              <div className="row">
                {/* Firebase API Key */}

                <div className="col-md-12 mb-2">
                  <InputBox
                    label="Firebase API Key"
                    fieldname="firebase_key"
                    value={formData.firebase_key}
                    onChange={handleChange}
                    placeholder="Enter Firebase API Key"
                  />
                </div>
                {/* SMS Sender */}

                <div className="col-md-6 mb-2">
                  <InputBox
                    label="SMS Sender"
                    fieldname="sms_sender"
                    value={formData.sms_sender}
                    onChange={handleChange}
                    placeholder="Enter SMS Sender"
                  />
                </div>
                {/* SMS API Key */}

                <div className="col-md-6 mb-2">
                  <InputBox
                    label="SMS API Key"
                    fieldname="sms_apikey"
                    value={formData.sms_apikey}
                    onChange={handleChange}
                    placeholder="Enter SMS API Key"
                  />
                </div>
              </div>
              <div className="clearfix"></div>
              <div className="row">
                {/* SMTP Host */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SMTP Host"
                    fieldname="smtp_host"
                    value={formData.smtp_host}
                    onChange={handleChange}
                    placeholder="Enter SMTP Host"
                  />
                </div>
                {/* SMTP Username */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SMTP Username"
                    fieldname="smtp_username"
                    value={formData.smtp_username}
                    onChange={handleChange}
                    placeholder="Enter SMTP Username"
                  />
                </div>
                {/* SMTP Password */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SMTP Password"
                    fieldname="smtp_password"
                    value={formData.smtp_password}
                    onChange={handleChange}
                    placeholder="Enter SMTP Password"
                  />
                </div>
                {/* SMTP Print Username */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SMTP Invoice Email Username"
                    fieldname="smtp_print_username"
                    value={formData.smtp_print_username}
                    onChange={handleChange}
                    placeholder="Enter SMTP Username"
                  />
                </div>
                {/* SMTP Print Password */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SMTP Invoice Email Password"
                    fieldname="smtp_print_password"
                    value={formData.smtp_print_password}
                    onChange={handleChange}
                    placeholder="Enter SMTP Password"
                  />
                </div>
                {/* SMTP Secure */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SMTP Secure"
                    fieldname="smtp_secure"
                    value={formData.smtp_secure}
                    onChange={handleChange}
                    placeholder="Enter SMTP Secure"
                  />
                </div>
                {/* SMTP Port */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="SMTP Port"
                    fieldname="smtp_port"
                    value={formData.smtp_port}
                    onChange={handleChange}
                    placeholder="Enter SMTP Port"
                  />
                </div>
                {/* Email From */}

                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Email From"
                    fieldname="emailfrom"
                    value={formData.emailfrom}
                    onChange={handleChange}
                    placeholder="Enter Email From"
                  />
                </div>
                {/* Mailer Name */}
                <div className="col-md-4 mb-2">
                  <InputBox
                    label="Mailer Name"
                    fieldname="mailer_name"
                    value={formData.mailer_name}
                    onChange={handleChange}
                    placeholder="Enter Mailer Name"
                  />
                </div>
              </div>

              <div className="clearfix"></div>
              <SubmitButton
                pageBack="/Settings/Company"
                handleSubmit={handleSubmit}
              />
            </div>
          </form>
        </div>

        {/* Scroll to Top Button */}
        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default ConfigForm;
